// extracted by mini-css-extract-plugin
export default {"root":"CookiePolicy_root__+7ZdA","widget":"CookiePolicy_widget__o9UPM"};